module.exports = __webpack_public_path__ + "d6dc91c0cfaa10f394ae1cf3209706aa.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/source-sans-pro/sourcesanspro-semibold.ttf
// module id = 37
// module chunks = 0 1 2 3 4 5 6 7 8 9